"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateTourLink = exports.canGenerateTourLink = void 0;
var localUrl;
if (typeof window === 'undefined' || typeof process === 'object') {
    localUrl = require('url').URL;
}
else {
    localUrl = URL;
}
var APT_LIVING_URL = 'http://apt-living.co';
var SCHEDULE_TOUR_PATH = 'schedule-tour';
/**
 * Determines if the user is able to use auto-generated
 * tour scheduling links.
 *
 * @param user - The user to test
 * @returns True if the user can auto-generate a tour scheduling link
 */
var canGenerateTourLink = function (user) {
    var _a;
    if (!user) {
        return false;
    }
    var isIntegratedUser = user.claims.includes('rentcafe') || user.claims.includes('realpage') || user.claims.includes('entrata') || user.claims.includes('knock') || user.claims.includes('rentdynamics');
    var hasScheduleATourPermissions = user.claims.includes('schedule-a-tour');
    var hasTourSchedulingEnabled = ((_a = user.widgetFeatures) === null || _a === void 0 ? void 0 : _a.includes('nbw-schedule-a-tour')) || false;
    return isIntegratedUser && hasScheduleATourPermissions && hasTourSchedulingEnabled;
};
exports.canGenerateTourLink = canGenerateTourLink;
/**
 * Generates a link to the standalone tour scheduling widget
 *
 * @param widgetToken - The widget access token
 * @param contact - The contact to send to
 * @returns A pre-generated link to the standalone tour scheduling widget
 */
var generateTourLink = function (widgetToken, contact) {
    var baseUrl = new localUrl(SCHEDULE_TOUR_PATH, APT_LIVING_URL);
    baseUrl.searchParams.append('token', widgetToken.token);
    if (contact.firstName) {
        baseUrl.searchParams.append('firstname', contact.firstName);
    }
    if (contact.lastName) {
        baseUrl.searchParams.append('lastname', contact.lastName);
    }
    if (contact.emailAddress) {
        baseUrl.searchParams.append('email', contact.emailAddress);
    }
    if (contact.phoneNumber) {
        baseUrl.searchParams.append('phone', contact.phoneNumber);
    }
    return baseUrl.toString();
};
exports.generateTourLink = generateTourLink;
